import { Component, Emit, Inject, Prop, Vue } from 'vue-property-decorator';
import { MenuService } from '@gv/ammo-astra';
import { AlertService, GoLeftDrawerComponent as GoLeft } from '@gv/ammo-grome';

@Component({
  components: {
    'go-left-drawer': GoLeft,
  },
})
export default class LeftDrawer extends Vue {
  // Sidebar menus served by panther through jaguar (replaces aurora/Nova — see wibault
  // docs/prd/menu/menu-management.md); provided in main.ts, shared with grome GoApps
  @Inject('menuService')
  private menuService!: () => MenuService;

  @Inject('alertService')
  private alertService!: () => AlertService;

  @Emit('click')
  // eslint-disable-next-line
  leftBubbleUp(e: any) {}

  @Prop(String) menu!: string;

  @Prop(String) resolveLocalPrefix!: string;

  // eslint-disable-next-line
  private items: Array<{ [k: string]: any }> = [];

  created(): void {
    this.retrieve();
  }

  private get authorizedItems() {
    return this.items;
  }

  public get authenticated(): boolean {
    return this.$store.getters.authenticated;
  }

  public retrieve(): void {
    this.menuService()
      .sideBarMenu(this.menu)
      .then(res => {
        this.items = res;
      })
      .catch(error => {
        this.alertService().showHttpError(this, error.response);
      });
  }
}
